/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
// @ts-nocheck
import { AfterContentInit, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngrx/store";
import { AnalyticsService } from "@services/support/analytics.service";
import { ConfigService } from "@services/support/config.service";
import accountSelectors from "@state/account/selectors";
import { LoadingState, State } from "@state/models";
import userSelectors from "@state/user/selectors";
import { environment } from "environments/environment";
import { NgxFreshChatService } from "ngx-freshchat";
import { take } from "rxjs/operators";

@UntilDestroy()
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, AfterContentInit {
  user$ = this.store.select(userSelectors.user);

  constructor (
    private store: Store<State>,
    private configService: ConfigService,
    private chat: NgxFreshChatService,
    private analyticsService: AnalyticsService) { }

  async ngOnInit () {
    this.configService.initTheme();

    if (environment.production) {
      this.initChat();
      this.disableRightClick();
    }
    this.initGA();
  }

  ngAfterContentInit () {
    this.initHJ();
  }

  private initChat () {
    this.user$.pipe(untilDestroyed(this)).subscribe(async (user) => {
      if (user.state !== LoadingState.loaded) {
        try {
          //usuário deslogado, desliga o chat
          this.chat.destroy();
        } catch {
        }
      } else {
        const subs = this.store
          .select(accountSelectors.currentAccount)
          .subscribe(async (account) => {
            if (account) {
              //usuário logado, inicia o chat
              this.chat.init({
                token: environment.freshChat.token,
                host: environment.freshChat.host,
                siteId: "Huntag V2",
                firstName: user.firstName,
                email: user.email,
                config: {
                  headerProperty: {
                    direction: "ltr"
                  }
                }
              }).pipe(take(1)).subscribe(() => {
                this.chat.setUserProperties({
                  userId: user.userId,
                  accountId: account.accountId,
                  accountName: account.name
                }).pipe(take(1)).subscribe();
                subs.unsubscribe();
              });
            }
          });
      }
    });
  }

  private initGA () {
    this.user$.pipe(untilDestroyed(this)).subscribe(async (user) => {
      if (user.state === LoadingState.loaded) {
        const subs = this.store
          .select(accountSelectors.currentAccount)
          .subscribe(async (account) => {
            if (account && account.googleAnalyticsMeasurementId) {
              this.analyticsService.initializeAnalytics(account.googleAnalyticsMeasurementId);
            }
          });
      }
    });
  }

  private initHJ () {
    this.user$.pipe(untilDestroyed(this)).subscribe(async (user) => {
      if (user.state === LoadingState.loaded) {
        const subs = this.store
          .select(accountSelectors.currentAccount)
          .subscribe(async (account) => {
            const hjscript = document.getElementById("hjscript");

            if (hjscript) {
              hjscript.remove();
            }

            if (account?.hotjarMeasurementId) {
              const script = document.createElement("script");
              script.textContent = `
                ((h, o, t, j, a, r) => {
                  h.hj =
                    h.hj ||
                    function () {
                      (h.hj.q = h.hj.q || []).push(arguments);
                    };
                  h._hjSettings = { hjid: ${account?.hotjarMeasurementId}, hjsv: 6 };
                  a = o.getElementsByTagName("head")[0];
                  r = o.createElement("script");
                  r.async = 1;
                  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                  a.appendChild(r);
                })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
              `;
              script.id = "hjscript";
              document.head.appendChild(script);
            }
          });
      }
    });
  }

  private disableRightClick () {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
  }
}
